// Phone validator: only digits, spaces, and plus sign allowed; must have 9-12 digits
export function phoneDigitsValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value || '';
  // Only allow digits, spaces, and plus sign
  if (/[^\d +]/.test(value)) {
    return { phoneAllowedChars: true };
  }
  // Remove all non-digits to count digits
  const digits = value.replace(/\D/g, '');

  if (!digits) return { required: true };

  // If value starts with '+61', must have exactly 9 digits after +61
  if (value.trim().startsWith('+61')) {
    if (digits.length !== 11 || !digits.startsWith('61')) {
      return { phoneDigits: true };
    }
    // Check that after '61' there are exactly 9 digits (so total 11 digits: '61' + 9)
    if (digits.slice(2).length !== 9) {
      return { phoneDigits: true };
    }
  } else {
    // If no '+61', must be 9 or 10 digits only
    if (digits.length < 9 || digits.length > 10) {
      return { phoneDigits: true };
    }
  }
  return null;
}
import { Component, Input, OnInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';

import { AuthenticationService } from '../../../services/auth/authentication.service';
import {
  ActivatedRoute,
  Router,
  NavigationStart,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { environment } from '../../../../environments/environment';
import { CommonService } from 'src/app/services/api/common.service';
import { NgxUiLoaderService } from 'ngx-ui-loader'; // Import NgxUiLoaderService
import { MixpanelService } from 'src/app/mixpanel.service';
// declare var myExternalJs: any;
import { SharedService } from 'src/app/services/api/message.service';
import { CommonAnnouncementComponent } from 'src/app/pages/common/common-announcement/common-announcement.component';
import { Subscription } from 'rxjs';
import { DirectivesModule } from 'src/app/directives.module';
import { ToastrService } from 'ngx-toastr';
import { co, el } from '@fullcalendar/core/internal-common';
import { CommonModule } from '@angular/common';
import { AbstractControl, ValidationErrors, ValidatorFn, FormGroup } from '@angular/forms';
import { set } from 'lodash';
// Email match validator
export function emailMatchValidator(form: AbstractControl): ValidationErrors | null {
  const email = form.get('email')?.value;
  const confirm_email = form.get('confirm_email')?.value;
  return email && confirm_email && email !== confirm_email ? { emailMismatch: true } : null;
}

// Password match validator
export function passwordMatchValidator(form: AbstractControl): ValidationErrors | null {
  const password = form.get('password')?.value;
  const confirm_password = form.get('confirm_password')?.value;
  return password && confirm_password && password !== confirm_password ? { passwordMismatch: true } : null;
}
@Component({
  selector: 'app-sign-up',
  standalone: true,
  imports: [
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    CommonAnnouncementComponent,
    RouterLink,
    RouterLinkActive,
    CommonModule
  ],
  templateUrl: './sign-up.component.html',
  styleUrl: './sign-up.component.scss'
})

export class SignUpComponent {
  showLoginBtn: boolean = false;
  otpSendCount: number = 0;
  maxOtpSends: number = 2; // Maximum allowed OTP sends (initial + 1 resend)
  constructor(
    private _router: Router,
    private loginFormFB: FormBuilder,
    private authService: AuthenticationService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private mixpanelService: MixpanelService,
    private sharedService: SharedService,
    private toastr: ToastrService,
    private fb: FormBuilder,
  ) {

  }
  @Input() announcementData = ''; // Your dynamic message
  terms_accepted: any;
  showAcceptBtn: boolean = false;
  emailExistsError: string = '';
  showOtpInput: boolean = false;
  otp: string[] = ['', '', '', '', '', ''];
  mfaUserId: string = '';
  otpError: string = '';
  userEmail: any;
  expiryTime: number = 10;
  isSmsOtpSent: boolean = false;
  otpTimer: number = 0;
  otpTimerInterval: any = null;
  canResendOtp: boolean = false;
  @ViewChildren('digit0, digit1, digit2, digit3, digit4, digit5') digitInputs!: QueryList<ElementRef>;
  mandatoryMessage: boolean = false;
  validationMessage: boolean = false;
  isMfaEnabled: boolean = true;
  error_log: any;
  loginForm: FormGroup = this.fb.group({
    client_id: [environment.client_id],
    client_secret: [environment.client_secret],
    grant_type: ['password'],
    username: ['', Validators.required],
    password: ['', Validators.required]
  });

  public signUpForm = this.loginFormFB.group({
    email: [
      '',
      [
        Validators.required,
        Validators.email,
        this.blockQldEmail
      ]
    ],
    confirm_email: ['', [Validators.required, this.blockQldEmail.bind(this)]],
    phone: ['', [
      phoneDigitsValidator
    ]],
    password: ['', [
      Validators.required,
      Validators.minLength(8),
      Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/)
    ]],
    confirm_password: ['', [Validators.required]],
    is_terms_accepted: [false, [Validators.requiredTrue]]
  }, {
    validators: [emailMatchValidator, passwordMatchValidator]
  });

  blockQldEmail(control: AbstractControl) {
    const value = control.value || '';

    if (/@(qed\.qld\.gov\.au|equ\.edu\.au|deta\.qld\.gov\.au|dete\.qld\.gov\.au|det\.qld\.gov\.au)$/i.test(value)) {
      return { qedQldEmailNotAllowed: true };
    }

    return null;
  }
  ngOnInit() {
    this.signUpForm.get('email')?.valueChanges.subscribe(() => {
      this.emailExistsError = '';
      this.showLoginBtn = false;
    });
  }
  checkCondition(event: any) {
    if (event.target.checked == true) {
      this.showAcceptBtn = true
    }
    if (event.target.checked == false) {
      this.showAcceptBtn = false
    }
  }
  signUpVerify() {
    if (this.signUpForm.invalid) {
      this.signUpForm.markAllAsTouched();
      return;
    }

    const formValue = this.signUpForm.value;
    // Check for 'from' param in URL
    let fromLearnworld = 0;
    this.route.queryParams.subscribe(params => {
      if (params['from'] && params['from'] === 'classcoverlearn') {
        fromLearnworld = 1;
      }
    });
    // Prepare payload (convert as needed)
    const payload = {
      email: formValue.email,
      phone: formValue.phone,
      password: formValue.password,
      is_terms_accepted: formValue.is_terms_accepted,
      confirm_email: formValue.confirm_email,
      confirm_password: formValue.confirm_password,
      from_learnworld: fromLearnworld,
      // Add other fields as needed
    };

    this.ngxService.start();
    this.otpSendCount = 1; // Initial OTP send
    this.commonService.signUpAPI(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          if (res.redirect_url) {
            window.location.href = res.redirect_url;
            return;
          }
          this.toastr.success(res.Message || 'Registration successful!');
          // this.toPageTredirection(res?.data?.properties?.user_type, '');
          this.showOtpInput = true
          this.mfaUserId = res.user_id;
          this.isMfaEnabled = true;
          this.startOtpTimer(60);
          this.userEmail = this.signUpForm.get('email')?.value;
          this.ngxService.stop();
          // Redirect or further actions
        } else {
          if (res.message === 'Email already exists') {
            this.toastr.error(res.message);
            this.emailExistsError = 'This email is already in use?';
            this.showLoginBtn = true;
            this.ngxService.stop();
            return;
          } else {
            this.emailExistsError = '';
            this.showLoginBtn = false;
            this.ngxService.stop();
            this.toastr.error(res.message || 'Signup failed');
          }

        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        this.toastr.error(err.message || 'Signup failed');
      }
    });
  }
  signUp() {
    if (this.signUpForm.invalid) {
      this.signUpForm.markAllAsTouched();
      return;
    }

    const formValue = this.signUpForm.value;
    // Check for 'from' param in URL
    let fromLearnworld = 0;
    this.route.queryParams.subscribe(params => {
      if (params['from'] && params['from'] === 'classcoverlearn') {
        fromLearnworld = 1;
      }
    });
    // Prepare payload (convert as needed)
    const payload = {
      email: formValue.email,
      phone: formValue.phone,
      password: formValue.password,
      is_terms_accepted: formValue.is_terms_accepted,
      confirm_email: formValue.confirm_email,
      confirm_password: formValue.confirm_password,
      from_learnworld: fromLearnworld,
      // Add other fields as needed
    };

    this.ngxService.start();
    this.commonService.signUpAPI(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          if (res.redirect_url) {
            window.location.href = res.redirect_url;
            return;
          }
          this.toastr.success('Signup successful!');
          // this.toPageTredirection(res?.data?.properties?.user_type, '');

          const user_email = this.signUpForm.get('email')?.value;
          const password = this.signUpForm.get('password')?.value;
          this.loginForm.patchValue({
            username: user_email,
            password: password
          });
          this.authService.loginOauth(this.loginForm.value).subscribe({
            next: (res) => {
              this.commonService.getUserData('').subscribe((res) => {
                if (res) {
                  var userRole = res.data.properties.user_type.replace(/[^a-zA-Z ]/g, "");
                  localStorage.setItem('userData', JSON.stringify(res.data));
                  localStorage.setItem('userRole', userRole);
                  document.cookie =
                    'userRole=' +
                    userRole +
                    ';domain=.' +
                    environment.cookiesDomain +
                    ';path=/';
                  this.toPageTredirection(res.data.properties.user_type, '');
                  this.ngxService.stop();
                } else {
                  console.log("error in the response", res);
                  this.toastr.error('error in login', res.message);
                  this.ngxService.stop();
                }
              });
            },
            error: (err) => {
              console.log(err);
            }
          })
          // Redirect or further actions
        } else {
          if (res.message === 'Email already exists') {
            this.toastr.error(res.message);
            this.emailExistsError = 'This email is already in use?';
            this.showLoginBtn = true;
            this.ngxService.stop();
            return;
          } else {
            this.emailExistsError = '';
            this.showLoginBtn = false;
            this.ngxService.stop();
            this.toastr.error(res.message || 'Signup failed');
          }

        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        this.toastr.error(err.message || 'Signup failed');
      }
    });
  }
  toPageTredirection(user: any, terms: any) {
    switch (user) {
      case 'Teacher':
        this._router.navigateByUrl('/teacher/profile');
        break;
    }
  }
  onOtpChange(index: number, event: any) {
    let value = event.target.value;
    // Only allow one digit per box
    if (value.length > 1) {
      value = value.slice(-1);
      event.target.value = value;
    }
    if (/^[0-9]?$/.test(value)) {
      this.otp[index] = value;
      // Only move focus if a digit was entered and only update the current box
      if (value && index < 5) {
        const nextInput = document.getElementById('otp-input-' + (index + 1));
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
  }

  verifyBtnDisable: boolean = false;
  onDigitInput(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (value.length === 1 && index < 5) {
      const nextInput = this.digitInputs.get(index + 1);
      if (nextInput) {
        (nextInput.nativeElement as HTMLInputElement).focus();
      }
    } else if (event.key === 'Backspace' && index > 0 && !value) {
      const prevInput = this.digitInputs.get(index - 1);
      if (prevInput) {
        (prevInput.nativeElement as HTMLInputElement).focus();
      }
    }
    this.verifyBtnDisable = (this.otp.every(digit => digit.length === 1));


  }
  startOtpTimer(seconds: number) {
    this.otpTimer = seconds;
    this.canResendOtp = false;
    if (this.otpTimerInterval) {
      clearInterval(this.otpTimerInterval);
    }
    this.otpTimerInterval = setInterval(() => {
      this.otpTimer--;
      if (this.otpTimer <= 0) {
        if (this.otpSendCount < this.maxOtpSends) {
          this.canResendOtp = true;
        } else {
          this.canResendOtp = false;
        }
        clearInterval(this.otpTimerInterval);
      }
    }, 1000);
  }
  resendOtp() {
    if (!this.canResendOtp || this.otpSendCount >= this.maxOtpSends) return;
    this.otpSendCount++;
    if (this.otpSendCount >= this.maxOtpSends) {
      this.canResendOtp = false;
      return;
    }
    this.commonService.resendMFAOtp({ user_id: this.mfaUserId }).subscribe({
      next: (res: any) => {
        this.startOtpTimer(res.cooldown || 60);
        this.canResendOtp = false;
        this.toastr.success('OTP has been resent successfully.');
      },
      error: () => {
        // Optionally show error
      }
    });
  }
  resendEmailOtp() {
    if (!this.canResendOtp || this.otpSendCount >= this.maxOtpSends) return;
    this.otpSendCount++;
    if (this.otpSendCount >= this.maxOtpSends) {
      this.canResendOtp = false;
      return;
    }
    this.commonService.resendVerifyOtp({ user_id: this.mfaUserId }).subscribe({
      next: (res: any) => {
        this.startOtpTimer(res.cooldown || 60);
        this.canResendOtp = false;
        this.toastr.success('OTP has been resent successfully.');
      },
      error: () => {
        // Optionally show error
      }
    });
  }
  sendSmsOtp() {
    this.ngxService.start();
    this.commonService.sendSmsMFAOtp({ user_id: this.mfaUserId }).subscribe({
      next: (res: any) => {
        if (res && res.status) {
          this.toastr.success(res.message || 'SMS OTP has been sent successfully.');
          this.isSmsOtpSent = true;
        } else {
          this.toastr.error(res?.message || 'Failed to send SMS OTP.');
        }
        this.ngxService.stop();
      },
      error: (err) => {
        this.toastr.error('Failed to send SMS OTP.');
        this.ngxService.stop();
      }
    });
  }
  submitEmailVerification() {

    this.otpError = '';
    const otpValue = this.otp.join('');

    if (otpValue.length !== 6) {
      this.otpError = 'Please enter the 6-digit OTP.';
      return;
    }
    const payload = { user_id: this.mfaUserId, otp: otpValue, mfa_enabled: this.isMfaEnabled };

    this.authService.loginEmailVerify(payload).subscribe({
      next: (res) => {
        if (!res.status) {
          this.otpError = res.message || 'Invalid code. Please check and try again.';
          this.ngxService.stop();
          return
        }
        this.toastr.success(res.message || 'Email verified successfully!');
        setTimeout(() => {
          this.commonService.getUserData('').subscribe((res) => {
            if (res) {
              var userRole = res.data.properties.user_type.replace(/[^a-zA-Z ]/g, "");
              localStorage.setItem('userData', JSON.stringify(res.data));
              localStorage.setItem('userRole', userRole);
              document.cookie =
                'userRole=' +
                userRole +
                ';domain=.' +
                environment.cookiesDomain +
                ';path=/';
              this.toPageTredirection(res.data.properties.user_type, '');
              this.ngxService.stop();
            } else {
              console.log("error in the response", res);
              this.toastr.error('Error in login', res.message);
              this.ngxService.stop();
            }
          });
        }, 1000);

      },
      error: (err) => {
        this.ngxService.stop();
        this.sharedService.announcement.next(
          'An error occurred while fetching user data.'
        );
        this.mandatoryMessage = false;
        this.validationMessage = true;
        this.error_log = err.error.error_log;
        this.sharedService.announcement.next(err.error.error_log);
        this.ngxService.stop();
      },
    });
  }

  onToggleChange(event?: any) {
    this.isMfaEnabled = event?.target?.checked;
  }

  showPassword = false;

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  showRePassword = false;

  toggleRePassword() {
    this.showRePassword = !this.showRePassword;
  }
}
